import { User } from "lucide-react";
import { UserAPI } from "../../services/apiService";

export const getProfile = async () => {
  const response = await UserAPI.viewProfile();
  return response.data;
};

export const updateProfile = async (data) => {
  // Validate name first
  if (!data.name?.trim()) {
    throw new Error("Name is required");
  }

  const formData = new FormData();

  formData.append("name", data.name.trim());

  if (data.phone?.trim()) formData.append("phone", data.phone.trim());
  if (data.company_name?.trim())
    formData.append("company_name", data.company_name.trim());
  if (data.trade_preferences?.trim())
    formData.append("trade_preferences", data.trade_preferences.trim());

  if (data.profile_image instanceof File) {
    formData.append("profile_image", data.profile_image);
  }

  const response = await UserAPI.updateProfile(formData);
  return response.data;
};

export const getAddressList = async (data) => {
  const response = await UserAPI.addressList(data);
  return response.data;
};

export const updateAddress = async (data) => {
  const response = await UserAPI.updateAddress(data);
  return response.data;
};

export const changePassword = async (data) => {
  const response = await UserAPI.changePassword(data);
  return response.data;
};

export const uploadKyc = async (formData) => {
  const response = await UserAPI.kycUpload(formData);
  return response.data;
};

export const getKycList = async () => {
  const response = await UserAPI.kycList();
  console.log("FULL KYC RESPONSE:", response);
  return response.data.data.kyc;
};

export const getNotificationList = async () => {
  const response = await UserAPI.notoficationsList();
  return response.data;
};

export const notificationsMarkRead = async (id) => {
  const response = await UserAPI.notificationsMarkRead(id);
  return response.data;
};

export const notificationsClearAll = async () => {
  const response = await UserAPI.notificationsClearAll();
  return response.data;
};

export const tradePrefrenceOptions = async () => {
  const response = await UserAPI.tradePrefrenceOptions();
  return response.data;
};

export const tradePreferenceStore = async (data) => {
  const response = await UserAPI.tradePreferenceStore(data);
  return response.data;
};

export const mytradePreference = async () => {
  const response = await UserAPI.mytradePreference();
  return response.data;
};

export const blogsCategories = async () => {
  const response = await UserAPI.blogsCategories();
  return response.data;
};

export const blogsList = async () => {
  const response = await UserAPI.blogsList();
  return response.data;
};

export const blogsByCategory = async (id) => {
  const response = await UserAPI.blogsByCategory(id);
  return response.data;
};

export const blogDetailBySlug = async (slug) => {
  const response = await UserAPI.blogDetailBySlug(slug);
  return response.data;
};

export const commonPages = async () => {
  const response = await UserAPI.commonPages();
  return response.data;
};

export const pageDetailBySlug = async (slug) => {
  const response = await UserAPI.pageDetailBySlug(slug);
  return response.data;
};

export const siteMapUrls = async () => {
  const response = await UserAPI.siteMapUrls();
  return response.data;
};

export const footerLinks = async () => {
  const response = await UserAPI.footerLinks();
  return response.data;
};

export const priceExchangeRate = async (currency, unit) => {
  const response = await UserAPI.priceExchangeRate(currency, unit);
  return response.data;
};

export const charts = async (params) => {
  const response = await UserAPI.charts(params);
  return response.data;
};

export const news = async () => {
  const response = await UserAPI.news();
  return response.data;
};

export const editImage = async (formData) => {
  // const formData = new FormData();
  // formData.append("image", data.file);
  // formData.append("action", data.action);

  const response = await UserAPI.editImage(formData);
  return response.data;
};

export const chatCreation = async (params) => {
  const response = await UserAPI.chatCreation(params);
  return response.data;
};

export const sendMessage = async (params) => {
  const response = await UserAPI.sendMessage(params);
  return response.data;
};

export const chatMessages = async (id) => {
  const response = await UserAPI.chatMessages(id);
  return response.data;
};

export const chatThreads = async () => {
  const response = await UserAPI.chatThreads();
  return response.data;
};

export const markAsRead = async (id) => {
  const response = await UserAPI.markAsRead(id);
  return response.data;
};

export const typing = async (id) => {
  const response = await UserAPI.typing(id);
  return response.data;
};

export const unreadCount = async () => {
  const response = await UserAPI.unreadCount();
  return response.data;
};

export const dispute = async (id) => {
  const response = await UserAPI.dispute(id);
  return response.data;
};

export const chatSupportCreation = async (params) => {
  const response = await UserAPI.chatSupportCreation(params);
  return response.data;
};

export const sendSupportMessage = async (params) => {
  const response = await UserAPI.sendSupportMessage(params);
  return response.data;
};

export const chatSupportMessages = async (id) => {
  const response = await UserAPI.chatSupportMessages(id);
  return response.data;
};

export const chatSupportThreads = async () => {
  const response = await UserAPI.chatSupportThreads();
  return response.data;
};

export const markSupportAsRead = async (id) => {
  const response = await UserAPI.markSupportAsRead(id);
  return response.data;
};

export const closeSupportChat = async (id) => {
  const response = await UserAPI.closeSupportChat(id);
  return response.data;
};

export const switchRole = async (data) => {
  const response = await UserAPI.switchRole(data);
  return response.data;
};

export const verifyRoleOtp = async (data) => {
  const response = await UserAPI.verifyRoleOtp(data);
  return response.data;
};

export const userService = {
  getProfile,
  updateProfile,
  getAddressList,
  updateAddress,
  changePassword,
  uploadKyc,
  getKycList,
  getNotificationList,
  notificationsMarkRead,
  notificationsClearAll,
  tradePrefrenceOptions,
  tradePreferenceStore,
  mytradePreference,
  blogsCategories,
  blogsList,
  blogsByCategory,
  blogDetailBySlug,
  commonPages,
  pageDetailBySlug,
  siteMapUrls,
  footerLinks,
  priceExchangeRate,
  editImage,
  charts,
  news,
  chatCreation,
  sendMessage,
  chatMessages,
  chatThreads,
  markAsRead,
  typing,
  unreadCount,
  dispute,
  chatSupportCreation,
  sendSupportMessage,
  chatSupportMessages,
  chatSupportThreads,
  markSupportAsRead,
  closeSupportChat,
  switchRole,
  verifyRoleOtp,
};
